const header = `
    <link href="https://fonts.googleapis.com/css2?family=Lato:ital@0;1&family=Literata:ital,opsz,wght@0,7..72,600;1,7..72,600&display=swap" rel="stylesheet">
    <link async rel="stylesheet" href="https://cdn.jsdelivr.net/npm/semantic-ui@2/dist/semantic.min.css" />

    <!-- Global site tag (gtag.js) - Google Analytics -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-115172742-1"></script>
    <script>
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'UA-115172742-1');
    </script>
    <!-- Active Campaign Script -->
    <script type="text/javascript">
    (function(e, t, o, n, p, r, i) {
            e.visitorGlobalObjectAlias = n;
            e[e.visitorGlobalObjectAlias] = e[e.visitorGlobalObjectAlias] || function() {
                (e[e.visitorGlobalObjectAlias].q = e[e.visitorGlobalObjectAlias].q || []).push(arguments)
            };
            e[e.visitorGlobalObjectAlias].l = (new Date).getTime();
            r = t.createElement("script");
            r.src = o;
            r.async = true;
            i = t.getElementsByTagName("script")[0];
            i.parentNode.insertBefore(r, i)
        })(window, document, "https://diffuser-cdn.app-us1.com/diffuser/diffuser.js", "vgo");
        vgo('setAccount', '226130963');
        vgo('setTrackByDefault', true);
        vgo('process');
    </script>
    <!-- Escalated Code -->
    <script>
    window.myCallback = function(result, scriptTag, trafficType, risk) {
        /*
        if (trafficType === 1002) {
        window.location.href = "https://app.healthcasts.com/ivt.html";
        return;
        }
        */
    }
    </script>
    `;

const assetStyles = `
    <style>
        .banner {
            background-repeat:no-repeat;
            background-size: cover;
            height: auto;
            padding: 30px 0 30px 30px;
        }
        .tag {
            background-repeat:no-repeat;
            background-size: cover;
            height: auto;
            padding: 30px 10px 30x 0;
            align: right;
        }
        .tag_eventrecap {
            background-image: url("https://app.healthcasts.com/site/supporting_asset_files/php/desktop/assets/MS_TEMPLATES/MS_images/tag-event-recap.png");
        }
        .tag_clinicalperspectives {
            background-image: url("https://app.healthcasts.com/site/supporting_asset_files/php/desktop/assets/MS_TEMPLATES/MS_images/tag-clinical-perspectices.png");
        }
        .tag_communityconsensus {
            background-image: url("https://app.healthcasts.com/site/supporting_asset_files/php/desktop/assets/MS_TEMPLATES/MS_images/tag-community-consensus.png");
        }
        .tag_experoncall {
            background-image: url("https://app.healthcasts.com/site/supporting_asset_files/php/desktop/assets/MS_TEMPLATES/MS_images/tag-expert-oncall.png");
        }
        .tag_expertperspectives {
            background-image: url("https://app.healthcasts.com/site/supporting_asset_files/php/desktop/assets/MS_TEMPLATES/MS_images/tag-expert-perspectives.png");
        }
        .tag_regionalperspectives {
            background-image: url("https://app.healthcasts.com/site/supporting_asset_files/php/desktop/assets/MS_TEMPLATES/MS_images/tag-regional-perspectives.png");
        }
        .banner_inner_area {
            width: 90%;
        }
        .banner_inner_line {
            border-top: #707070  solid 1px;
            width: 90%;
            height: 10px;
            margin: 0px 0px 0px 20px;
        }
        .banner_inner_text1 {
            font-size: 50px;
            line-height: 45px;
            padding: 0px 0px 0px 20px;
            font-family: 'Lato', sans-serif;
            font-weight: 400;
            letter-spacing: 22px;
            color: #ffffff;
            text-align: left;
            text-transform: uppercase;
        }
        .banner_inner_text2 {
            font-size: 27px;
            line-height: 36px;
            padding: 0px 0px 0px 20px;
            font-family: 'Lato', sans-serif;
            font-weight: 400;
            letter-spacing: 20px;
            color: #ffffff;
            text-align: left;
            text-transform: uppercase;
        }
        .banner_inner_text3 {
            font-size: 24px;
            padding: 5px 0px 0px 20px;
            font-family: 'Lato', sans-serif;
            font-weight: 300;
            letter-spacing: 5px;
            color: #ffffff;
            text-align: left;
            text-transform: uppercase;
        }
        .banner_inner_text4 {
            font-size: 20px;
            padding: 0px 0px 0px 20px;
            font-family: 'Lato', sans-serif;
            letter-spacing: 5px;
            font-weight: 300;
            color: #ffffff;
            text-align: left;
            text-transform: uppercase;
        }
        .banner_inner_text5 {
            font-size: 16px;
            padding: 0px 0px 0px 20px;
            font-family: 'Lato', sans-serif;
            font-weight: 300;
            color: #ffffff;
            text-align: left;
            text-transform: uppercase;
        }
        .banner_portrait {
            height: auto;
            width: 90%;
            max-width: 100px;
        }
        .banner_portrait_col {
            width: 20%;
            max-width: 150px;
        }
        .banner_tall {
            padding: 30px 0 30px 0;
        }
        .banner_logo {
            height: 10%;
            width: auto;
            max-height: 75px;
            align: left;
            padding: 30px 0 30px 30px;
        }
        .banner_ad {
            width: auto;
            max-height: 90px;
            align: center;
            padding: 0 0 0 0;
        }
        .main_body{
            width: 80%;
            max-width: 1200px;
            min-height: 1000px; height: auto;
            overflow: auto;
            background: #ffffff;
            box-shadow: 0px 10px 24px 0px rgba(0,0,0,0.18);
        }
        .main_body_text8 {
            background: #F8F7F7;
            background-repeat:no-repeat;
            background-size: 60px 60px;
            background-position: 10px 30px;
            font-size: 15px;
            padding: 20px 30px 30px 30px;
            font-family: 'Lato', sans-serif;
            font-weight: 500;
            color: #282440;
            text-align: left;
        }
        .main_body_text1 {
            font-size: 18px;
            padding: 10px 30px 10px 30px;
            font-family: 'Lato', sans-serif;
            font-weight: 300;
            color: #39312b;
            text-align: left;
        }
        .adplugg-tag {
            width: 100%;
        }
        .main_body_textAD {
            font-size: 9px;
            padding: 5px 0 30px 0;
            font-family: 'Lato', sans-serif;
            font-weight: 500;
            color: #282440;
            text-align: center;
        }
        .color_option0{
            color: #707070;
        }
        @media (min-width: 601px) and (max-width: 900px) {
            .banner {
                background-size: cover;
                height: auto;
            }
            .banner_inner_area {
                width: 95%;
            }
            .banner_inner_text1 {
                font-size: 40px;
                line-height: 36px;
                letter-spacing: 22px;
            }
            .banner_inner_text2 {
                font-size: 15px;
                line-height: 23px;
                letter-spacing: 18px;
            }
            .banner_inner_text3 {
                font-size: 15px;
            }
            .footer_sizing {
                height: 150px;
            }
            .main_body{
                width: 95%;
            }
        }

        @media (min-width: 300px) and (max-width: 600px) {
            .banner {
                background-size: cover;
                height: auto;
                padding: 10px 0 10px 10px;
            }
            .banner_inner_area {
                width: 100%;
            }
            .banner_inner_text1 {
                font-size: 24px;
                line-height: 27px;
                letter-spacing: 9px;
            }
            .banner_inner_text2 {
                font-size: 16px;
                line-height: 22px;
                letter-spacing: 9px;
            }
            .banner_inner_text3 {
                font-size: 13px;
            }
            .banner_inner_text4 {
                font-size: 15px;
            }
            .banner_inner_text4 {
                font-size: 13px;
            }
            .banner_portrait {
                height: auto;
                width: 100%;
                min-width: 70px;
            }
            .banner_portrait_col {
                width: 25%;
                max-width: 100px;
            }
            .footer_sizing {
                height: 100px;
            }
            .main_body{
                width: 95%;
            }
            .main_body_text1 {
                font-size: 16px;
                word-wrap: break-word;
            }
            .main_body_text2 {
                font-size: 17px;
            }
            .main_body_text3 {
                font-size: 14px;
                background-size: 0px 0px;
                padding: 10px 10px 10px 10px;
            }
            .main_body_text3-kol {
                font-size: 14px
                background-size: 60px 60px;
                padding: 10px 10px 10px 80px;
            }
            .main_body_text3-kol2 {
                font-size: 14px
                background-size: 60px 60px;
                padding: 10px 10px 10px 80px;
            }
            .main_body_text3-hc {
                font-size: 14px
                background-size: 60px 60px;
                padding: 10px 10px 10px 80px;
            }
            .main_body_text3-quote {
                font-size: 14px;
            }
            .main_body_text4 {
                font-size: 14px;
            }
            .main_body_text9 {
                font-size: 16px;
                padding: 5px 5px 5px 5px;
            }
            .main_body_text10 {
                font-size: 10px;
                padding: 0px;
            }
        }
        /* peer challenge styles */

            .peer-challenge-container {
                font-family: "Lato", sans-serif;
                color: #032246;
            }

            #program-top-header {
                position: relative;
                padding: 50px 220px;
            }
            #program-top-header h1 {
                font-family: "Times New Roman", Times, serif;
            }
            @media only screen and (max-width: 768px) {
                #program-top-header h1 {
                    font-size: 28px;
                }
                #program-top-header {
                    padding: 20px;
                    margin-left: 0px;
                    margin-right: 0px;
                }
            }
            @media only screen and (max-width: 1350px) {
                #program-top-header {
                    padding: 50px;
                    margin-left: 0px;
                    margin-right: 0px;
                }
            }

            #program-content {
                background: #FFFFFF;
                position: relative;
                padding: 50px 220px;
            }
            @media only screen and (max-width: 768px) {
                #program-content {
                    padding: 30px;
                    margin-left: 0px;
                    margin-right: 0px;
                }
            }
            @media only screen and (min-width: 770px) and (max-width: 1350px) {
                #program-content {
                    padding: 50px;
                    margin-left: 0px;
                    margin-right: 0px;
                }
            }
            #program-content #topic-anchors-container {
                display: flex;
                column-gap: 10px;
                row-gap: 10px;
                padding: 40px 0 0 0;
            }
            #program-content #topic-anchors-container a {
                padding: 6px 8px;
                color: #FFFFFF;
                background: #0B47C1;
                font-size: 12px;
                border-radius: 100px;
                text-align: center;
                display: flex;
                align-items: center;
            }
            #program-content #topic-anchors-container a span {
                width: 100%;
                text-align: center;
            }
            @media only screen and (max-width: 768px) {
            #program-content #topic-anchors-container {
                flex-direction: column;
                margin-bottom: 16px;
            }
            }
            #program-content #topic-content-container .topic-content {
                margin: 40px 0 0 0;
                scroll-margin-top: 100px;
            }
            #program-content #topic-content-container .topic-content .topic-title {
                color: #0052CC;
                font-weight: 400;
                font-size: 28px;
                line-height: 130%;
                word-break: break-word;
                margin-bottom: 25px;
            }
            #program-content #topic-content-container .topic-content .topic-description {
                margin: 0 0 40px 0;
            }
            #program-content #topic-content-container .topic-content .topic-description p {
                font-weight: 400;
                font-size: 16px;
                line-height: 150%;
                word-break: break-word;
            }
            #program-content #topic-content-container .topic-content .topic-question {
                border-left: 4px solid #3C6CCD;
                background: rgba(231, 237, 249, 0.5);
                padding: 32px;
                margin-bottom: 40px;
                font-size: 18px;
                font-style: italic;
            }
            @media only screen and (max-width: 768px) {
                #program-content #topic-content-container .topic-content .topic-question {
                    font-size: 16px;
                }
            }
            #program-content #topic-content-container .topic-content .topic-response {
                margin: 0 0 30px 0;
            }
            #program-content #topic-content-container .topic-content .topic-response img {
                border-style: solid;
                border-color: #CCCCCC;
            }
            #program-content #topic-content-container .back-to-top-btn-box {
                text-align: right;
            }
            #program-content #topic-content-container .back-to-top-btn {
                font-size: 15px;
            }
            #program-content #sources-container {
                color: #6D6685;
                font-weight: 400;
                font-size: 14px;
                line-height: 140%;
                padding: 100px 0;
            }
            #program-content #sources-container .source-information {
                margin-bottom: 10px;
            }
            #program-content #sources-container .source-information .source-date {
                font-weight: 600;
            }

        /* Footer */
        .action-link-tiles{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 24px;
            padding: 0 220px 96px 220px;
            font-family: 'Lato', sans-serif;
            background: #FFFFFF;
            position: relative;
        }
        @media only screen and (max-width: 1350px) {
            .action-link-tiles {
                padding: 0 80px 96px 80px;
            }
        }
        @media only screen and (max-width: 768px) {
            .action-link-tiles {
                flex-direction: column;
                padding: 0 24px 96px 24px;
            }
        }
        .action-link-tile {
            display: flex;
            flex-direction: column;
            padding: 24px 24px 32px;
            gap: 24px;
            background: #FFFFFF;
            border: 1px solid #E9EEFA;
            box-shadow: 4px 4px 8px rgba(12, 0, 51, 0.08), 8px 8px 24px rgba(12, 0, 51, 0.08);
            border-radius: 8px;
        }
        @media only screen and (min-width: 768px) {
            .action-link-tile {
                flex: 1 1 0;
                width: 0;
            }
        }
        .action-link-tile .cta-text {
            display: flex;
            flex-direction: column;
            height: 100%;
        }
        .action-link-tile .cta-text h2 {
            font-family: 'Literata', serif;
            font-size: 22px;
            letter-spacing: -0.005em;
            margin-bottom: 8px;
            color: #041C4D;
        }
        @media only screen and (max-width: 768px) {
            .action-link-tile .cta-text h2 {
                font-family: 'Literata', serif;
                font-size: 18px;
            }
        }
        .action-link-tile .cta-text p {
            font-family: 'Lato';
            font-weight: 400;
            font-size: 14px;
            line-height: 140%;
            color: #0C0033;
            margin-bottom: 16px;
            flex-grow: 1;
        }
        @media only screen and (max-width: 768px) {
            .action-link-tile .cta-text p {
                font-family: 'Lato';
                font-size: 12px;
                line-height: 150%;
            }
        }
        .action-link-tile .cta-text a {
            font-weight: 700;
            font-size: 16px;
            line-height: 125%;
            color: #8651CC;
        }

        /* Top banner */
        #top-banner-container {
            position: relative;
            display: block;
            padding: 20px 0;
            background-color: #f7f6f8;
        }

        #top-banner {
            width: auto;
            height: auto;
            background: transparent;
            position: relative;
            display: flex;
            margin: 0 auto;
            text-align: center;
            flex-flow: column;
            align-items: center;
        }

        /* Survey */
        .survey-container {
             font-family: "Lato", sans-serif;
            color: #032246;
            background: #FFFFFF;
            position: relative;
        }

        /* Chip */
        .chip {
            color: #fff !important;
            font-size: 12px !important;
            padding: 4px 8px;
            background: #8651CC;
            border-radius: 100px;
            width: fit-content;
        }

        .chip.purple {
            background: #8651CC;
        }

        .chip.blue {
            background: #0B47C1;
        }
    </style>`;

const adBanner = `
<!-- BANNER AD -->
    <div id="top-banner-container" style="padding: 20px 0 0 0;">
        <div id="top-banner">
            <!-- Top_Page_728x90 [async] -->
            <script type="text/javascript">if (!window.AdButler){(function(){var s = document.createElement("script"); s.async = true; s.type = "text/javascript";s.src = 'https://servedbyadbutler.com/app.js';var n = document.getElementsByTagName("script")[0]; n.parentNode.insertBefore(s, n);}());}</script>
            <script type="text/javascript">
                var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
                var abkw = window.abkw || '';
                var plc610311 = window.plc610311 || 0;
                document.write('<'+'div id="placement_610311_'+plc610311+'"></'+'div>');
                AdButler.ads.push({handler: function(opt){ AdButler.register(185098, 610311, [728,90], 'placement_610311_'+opt.place, opt); }, opt: { eventLogData: {"npi" : "<?php echo $user->npiNumber; ?>"}, place: plc610311++, dataKeys:{'db_id':'<?php echo $program->db_id; ?>'}, keywords: abkw, domain: 'servedbyadbutler.com', click:'CLICK_MACRO_PLACEHOLDER', extraData: 'firstname=<?php echo $user->firstName; ?>&lastname=<?php echo $user->lastName; ?>&email=<?php echo $user->email; ?>&npi=<?php echo $user->npiNumber; ?>' }});
            </script>

            <!-- Top_Page_300x250 [async] -->
            <script type="text/javascript">if (!window.AdButler){(function(){var s = document.createElement("script"); s.async = true; s.type = "text/javascript";s.src = 'https://servedbyadbutler.com/app.js';var n = document.getElementsByTagName("script")[0]; n.parentNode.insertBefore(s, n);}());}</script>
            <script type="text/javascript">
                var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
                var abkw = window.abkw || '';
                var plc610312 = window.plc610312 || 0;
                document.write('<'+'div id="placement_610312_'+plc610312+'"></'+'div>');
                AdButler.ads.push({handler: function(opt){ AdButler.register(185098, 610312, [300,250], 'placement_610312_'+opt.place, opt); }, opt: { eventLogData: {"npi" : "<?php echo $user->npiNumber; ?>"}, place: plc610312++, dataKeys:{'db_id':'<?php echo $program->db_id; ?>'}, keywords: abkw, domain: 'servedbyadbutler.com', click:'CLICK_MACRO_PLACEHOLDER', extraData: 'firstname=<?php echo $user->firstName; ?>&lastname=<?php echo $user->lastName; ?>&email=<?php echo $user->email; ?>&npi=<?php echo $user->npiNumber; ?>' }});
            </script>

            <!-- Top_mobile_320x50 [async] -->
            <script type="text/javascript">if (!window.AdButler){(function(){var s = document.createElement("script"); s.async = true; s.type = "text/javascript";s.src = 'https://servedbyadbutler.com/app.js';var n = document.getElementsByTagName("script")[0]; n.parentNode.insertBefore(s, n);}());}</script>
            <script type="text/javascript">
                var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
                var abkw = window.abkw || '';
                var plc613140 = window.plc613140 || 0;
                document.write('<'+'div id="placement_613140_'+plc613140+'"></'+'div>');
                AdButler.ads.push({handler: function(opt){ AdButler.register(185098, 613140, [320,50], 'placement_613140_'+opt.place, opt); }, opt: { eventLogData: {"npi" : "<?php echo $user->npiNumber; ?>"}, place: plc613140++, dataKeys:{'db_id':'<?php echo $program->db_id; ?>'}, keywords: abkw, domain: 'servedbyadbutler.com', click:'CLICK_MACRO_PLACEHOLDER', extraData: 'firstname=<?php echo $user->firstName; ?>&lastname=<?php echo $user->lastName; ?>&email=<?php echo $user->email; ?>&npi=<?php echo $user->npiNumber; ?>' }});
            </script>
            <div class="ad-indicator">
                Advertisement
            </div>
        </div>
    </div>
<!-- END BANNER AD -->`;

export const typeFormContent = `
    <div class="survey-container">
        <div class="survey-body">
            <iframe src='https://form.typeform.com/to/cns1Pfrs#user_id=<?php echo "{$user->pk_uID}&npi_id={$user->npiNumber}&first_name={$user->firstName}&last_name={$user->lastName}&email={$user->email}&prg_id={$program->db_id}" ?>' width="100%" height="350" frameborder="0" scrolling="no"></iframe>
        </div>
    </div>
    `;

export const footerContent = (demoUserFooterContent, hcpUserFooterContent) => (`
<?php if($user->db_id == 1534778 || $user->db_id == 1534771 || $user->db_id == 1532288){ ?>
    ${demoUserFooterContent}
<?php } else { ?>
    ${hcpUserFooterContent}
<?php } ?>
`);

const tileStyles = `
    <style>
        .tile-content {
            font-family: "Lato", sans-serif;
            color: #0C0033;
        }

        .tile-content .card {
            height: 308px;
            width: 260px;
            background-position: top left;
            background-repeat: no-repeat;
            background-size: contain;
            margin: 0 auto;
        }

    </style>
`;

// TODO: replace the need for this file by allowing a redirect from app.healthcasts.com
export const wrapAssetMarkup = (content, footer) => (
    `<meta name="viewport" content="width=device-width, initial-scale=1">
        ${header}
        ${assetStyles}
        <div class="content">
            <div class="main-container">
                ${adBanner}
                ${content}
            </div>
        </div>
        <div class="content">
            ${typeFormContent}
        </div>
        ${footer}
    </meta>`
);

export const wrapTileMarkup = content => (
    `
    <head>
        <link href="https://fonts.googleapis.com/css2?family=Lato:ital@0;1&family=Literata:ital,opsz,wght@0,7..72,600;1,7..72,600&display=swap" rel="stylesheet">
        ${tileStyles}
    </head>
    <!-- UPDATE ed_path url TO INCLUDE THE APPROPRIATE ASSET_ID -->
    <!-- UPDATE program_id TO REFLECT THE CORRECT VALUE -->
    ${content}
    `
);

export default { wrapAssetMarkup, wrapTileMarkup };
